<template>
  <button class="ui-lightbox-close"
      :class="{
        'video__pause offset white': $root.lightboxToggled.indexOf('lightboxVideo') > -1
      }"
    >
    <span>Close</span>
  </button>
</template>
<script>
export default {
  
};
</script>
